import { gql } from "@apollo/client";

export const ATTACH_POLICY = gql`
  mutation AttachPolicy($stackId: ID!, $policyId: ID!) {
    policyAttach(id: $policyId, stack: $stackId) {
      id
    }
  }
`;
